var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"p-0"},[_c('b-table',{staticClass:"p-0 m-0",attrs:{"items":_vm.items,"fields":_vm.fields,"busy":_vm.isBusy,"primary-key":"id","sticky-header":"90vh","no-border-collapse":_vm.noCollapse,"responsive":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }